import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../quick-links/index.js';
import '../search-bar/index.js';
import css_248z from './error-404.scss.js';

class Error404 extends s {
    render() {
        return x `<div class="error-404"><div class="error-404__image-con"><img class="error-404__image" src="${this.imageSrc}" alt=""></div><div class="error-404__content"><div class="error-404__text"><slot name="headline"></slot><slot name="subheadline"></slot><slot name="text"></slot></div><search-form showClearButton searchPageUrl="${this.searchPageUrl}" searchTitle="${this.searchTitle}" searchPlaceholder="${this.searchPlaceholder}" searchButtonText="${this.searchButtonText}"></search-form><slot name="quick-links"></slot></div></div>`;
    }
}
Error404.styles = css_248z;
__decorate([
    n({ type: String })
], Error404.prototype, "imageSrc", void 0);
__decorate([
    n({ type: String })
], Error404.prototype, "searchPageUrl", void 0);
__decorate([
    n({ type: String })
], Error404.prototype, "searchTitle", void 0);
__decorate([
    n({ type: String })
], Error404.prototype, "searchPlaceholder", void 0);
__decorate([
    n({ type: String })
], Error404.prototype, "searchButtonText", void 0);
customElements.define('error-404', Error404);

export { Error404 };
